module.exports = __webpack_public_path__ + "@/assets/img/doc.bc5f9db1.svg";